import script from "./noticePage.vue?vue&type=script&setup=true&lang=js"
export * from "./noticePage.vue?vue&type=script&setup=true&lang=js"

import "./noticePage.vue?vue&type=style&index=0&id=67c68db6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67c68db6"]])

export default __exports__